import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=af24f8fe&scoped=true"
import script from "./ImageWidget.vue?vue&type=script&lang=js"
export * from "./ImageWidget.vue?vue&type=script&lang=js"
import style0 from "./ImageWidget.vue?vue&type=style&index=0&id=af24f8fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af24f8fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af24f8fe')) {
      api.createRecord('af24f8fe', component.options)
    } else {
      api.reload('af24f8fe', component.options)
    }
    module.hot.accept("./ImageWidget.vue?vue&type=template&id=af24f8fe&scoped=true", function () {
      api.rerender('af24f8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/ImageWidget.vue"
export default component.exports